import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useMutation } from '@/composables/vue-query'

import AccountCard from '@/components/navbar/AccountCard.vue'
import DropdownMenu from '@/components/core/DropdownMenu.vue'
import MoreOptionsItem, {
  MoreOptionsItemProps,
} from '@/components/navbar/MoreOptionsItem.vue'
import { useSignOut, useOrganization, useUser } from '@/composables/auth'
import { useContext } from '@/composables/context'
import { authModule } from '@/store'
import { SocialLoginType } from '@/utils/enums'
import { loadScript } from '@/utils/utility-manager'
import { initials } from '@/utils/strings'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDropdown',
  setup(__props) {

const { $axios } = useContext()

const user = useUser()
const organization = useOrganization()
const { signOut } = useSignOut()

const organizations = computed(() =>
  (user.value.memberships ?? [])
    .filter((m) => m.organization._id !== organization.value._id)
    .map((m) => m.organization),
)

const moreOptionsItems = computed(() => {
  const moreOptions: (MoreOptionsItemProps & { id?: string })[] = [
    {
      title: 'settings',
      link: '/user/settings',
      component: 'NuxtLink',
      isExternal: false,
    },
  ]

  // add generall options
  moreOptions.push(
    {
      title: 'getHelp',
      link: process.env.LAMBUS_HELP_CENTER,
      component: 'a',
    },
    {
      title: 'seePrivacyPolicy',
      link: 'https://www.lambus.com/meta/privacy',
      component: 'a',
    },
    {
      title: 'seeTermsOfService',
      link: 'https://www.lambus.com/meta/terms',
      component: 'a',
    },
    {
      title: 'contactUs',
      link: '#',
      component: 'a',
      isExternal: false,
      id: 'intercom_launcher',
    },
  )

  return moreOptions
})

function logout(): void {
  const windowLocal = window as any

  const accountType = localStorage.getItem('kLambusAccountType')

  if (accountType === SocialLoginType.FACEBOOK) {
    if (!windowLocal.FB) {
      loadScript('fb-sdk', 'https://connect.facebook.net/de_DE/sdk.js', () => {
        windowLocal.FB.init({
          appId: process.env.FB_APP_ID,
          cookie: true,
          xfbml: true,
          version: 'v25.0',
        })
      })
    }

    logoutFB()
  } else if (accountType === SocialLoginType.GOOGLE) {
    if (!windowLocal.google?.accounts?.id) {
      loadScript('gsi-sdk', 'https://accounts.google.com/gsi/client', () => {
        windowLocal.google.accounts.id.initialize({
          client_id: process.env.GOOGLE_CLIENT_ID,
        })
      })
    }

    logoutGoogle()
  }

  signOut()
}

function logoutFB(): void {
  const windowLocal = window as any
  if (windowLocal.FB) {
    windowLocal.FB.getLoginStatus((response: any) => {
      if (response.status === 'connected') {
        windowLocal.FB.logout()
      }
    })
  }
}

function logoutGoogle(): void {
  const windowLocal = window as any
  if (windowLocal.google?.accounts?.id && authModule.user?.email) {
    windowLocal.google.accounts.id.revoke(authModule.user?.email)
  }
}

const { mutate: switchOrganization } = useMutation({
  mutationFn: async (organizationId: string) => {
    const { data } = await $axios.post('/api/organizations/switch', {
      organizationId,
    })
    return data
  },
  onSuccess: (data) => {
    authModule.setTokens({
      accessToken: data.token,
      refreshToken: data.refreshToken,
    })
    window.location.href = '/'
  },
})

return { __sfc: true,$axios, user, organization, signOut, organizations, moreOptionsItems, logout, logoutFB, logoutGoogle, switchOrganization, AccountCard, DropdownMenu, MoreOptionsItem, authModule, initials }
}

})